import { connect } from "react-redux";
import ResourceFloorPlan from "./index";
import { RootState } from "@/redux";
import {
  IFilterResource,
  IMessageFromDialog,
  IResourceService,
  ResourceInfo,
  TokenIResourceService,
} from "@/services";
import { baContainer } from "@/ioc";
import {
  DialogErrorCode,
  DialogEventType,
  DialogMessageBase,
  IDialogModel,
  OfficeDialogMessageType,
} from "@/index";
import { SelectedResourceChangeEventArgs } from "@/out-look/services";
import {
  FloorPlanInfo,
  IFetchFloorPlanRequest,
} from "@/services/resource-service/entity/FloorplanEntity";
import { HttpResponse } from "@/fetchInterceptor/AxiosMethod";
import {
  deleteSelectResource,
  selectResource,
  updateFilterResource,
} from "@/redux/slices/resources/ResourceSlice";
import { Dispatch } from "@reduxjs/toolkit";
import { DialogEventData, IDialogEventData } from "@/common/entity/Entity";

const mapDispatchToProps = (dispatch: Dispatch<any>) => {
  const resourceService: IResourceService = baContainer.resolve(
    TokenIResourceService
  );
  return {
    showFloorPlanDialog: (stateClone: RootState) => {
      const newCallBack = (dialog: IDialogModel) => {
        if (dialog != null) {
          dialog.addEventHandler(
            DialogEventType.DialogEventReceived,
            (args: any) => {
              //console.log(args, "Message from child");
              if (args.error == DialogErrorCode.Closed) {
                //emty
              }
            }
          );
          dialog.addEventHandler(
            DialogEventType.DialogMessageReceived,
            (args: IDialogEventData) => {
              const dialogEventData = new DialogEventData(args);
              const message: IMessageFromDialog = dialogEventData.message;
              const resourceInfo: ResourceInfo = new ResourceInfo(message.data);
              if (message) {
                switch (message.MessageType) {
                  case OfficeDialogMessageType.ResourceSelected:
                    dispatch(selectResource(resourceInfo));
                    break;
                  case OfficeDialogMessageType.DeResourceSelected:
                    dispatch(deleteSelectResource(resourceInfo));
                    break;
                  default:
                    break;
                }
              }
            }
          );
        }
      };
      resourceService.onShowFloorPlanDialog(0, newCallBack, stateClone);
    },
    onFetchResourceFloorPlan: (
      request: IFetchFloorPlanRequest
    ): Promise<FloorPlanInfo | null> => {
      return resourceService
        .fetchResourceFloorPlan(request)
        .then((resp: HttpResponse<FloorPlanInfo>) => {
          if (!resp.error) {
            return resp.data;
          } else {
            return null;
          }
        });
    },
    updateFilterResource: (filter: IFilterResource) => {
      dispatch(updateFilterResource(filter));
    },
  };
};

export default connect(null, mapDispatchToProps)(ResourceFloorPlan);
